<div class="text-drop-block article-paragraph-tooltip">
  <ng-component *ngIf="!blockElement?.isActiveForEdit"
    [innerHTML]="getSanitizedHtml(blockElement?.data)"></ng-component>
  <div *ngIf="blockElement?.isActiveForEdit" class="NgxEditor__Wrapper">
    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [customMenuRef]="customMenu"> </ngx-editor-menu>
    <ngx-editor [editor]="editor" [ngModel]="blockElement.data" (ngModelChange)="onChange($event)" [disabled]="false"
      [placeholder]="'Type here...'"></ngx-editor>
    <!-- popup -->
    <div class="NgxEditor__Popup tooltipModel" *ngIf="showPopup">
      <div class="NgxEditor__Popup--FormGroup">
        <div class="NgxEditor__Popup--Col">
          <label class="NgxEditor__Popup--Label">Seleted Text</label>
          <input type="text" [(ngModel)]="selectedText" ormControlName="text" autocomplete="off" />
        </div>
        <div class="NgxEditor__Popup--Col">
          <label class="NgxEditor__Popup--Label">Defination</label>
          <textarea [(ngModel)]="titleValue" ormControlName="text" autocomplete="off"></textarea>
        </div>
      </div>
      <button (click)="addTitle($event)" [disabled]=" !(titleValue&&selectedText)">add</button>
    </div>
    <ng-template #customMenu>
      <div class="NgxEditor__Seperator"></div>
      <div class="NgxEditor__MenuItem NgxEditor__MenuItem--Icon">
        <div class="NgxEditor__MenuItem--IconContainer" title="Tooltip"
          [ngClass]="{'NgxEditor__MenuItem--Active': isActiveBtn, 'NgxEditor--Disabled': !canExecuteBtn}"
          (mousedown)="onClick($event)">
          <img style="width: 20px; height:20px" src="../assets/images/ic-tooltip.svg" alt="Icon" />
        </div>
      </div>
    </ng-template>
  </div>
</div>